import React from "react";
import { createUseStyles } from "react-jss";
import classNames from "classnames";
import Container from "reactstrap/lib/Container";
import Row from "reactstrap/lib/Row";
import { Col } from "ComponentsUI/Styles/Grid";

const useStyles = createUseStyles((theme) => ({
	root: {
		width: "720px",
		margin: "20px auto 60px",
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		root: {
			width: "100%",
			margin: "20px 0 60px",
		},
	},
}));

const BlockButton = (props) => {
	let classes = useStyles();

	return (
		<Container>
			<div className={classes.root}>{props.children}</div>
		</Container>
	);
};

export default BlockButton;
